import React from 'react';
import PropTypes from 'prop-types';
import s from './returnItem.module.css';
import { getItemPropertyDisplay, getQuantity } from './helpers';
import { currencyService } from '../../services/currency-service/currency-service';
import ChangeIndicator from '../../react-components/ItemCard/ItemProperties/ChangeIndicator';
import { getDateTime } from '../../lib/dates';
import { ReturnDateViewType } from '../../constants/enums';
import { retailerSettingsService } from '../../services';
import { Language } from '../../react-components/Language';

export const ItemProperties = ({
  item,
  itemIndex,
  language,
  itemQty,
  exchangeAttributes,
  locale,
}) => {
  const showReturnDate =
    retailerSettingsService.getReturnDateViewType() === ReturnDateViewType.ItemsCard ||
    (item.max_return_date &&
      retailerSettingsService.getReturnDateViewType() === ReturnDateViewType.Dynamic);
  return (
    <div className={s.item_property_container}>
      <ul className={s.item_property_list}>
        {(item.item_properties || [])
          .filter((p) => p.displayable)
          .map((property, index) => {
            const propertyKey = property.key?.toLowerCase();
            return (
              <li key={index} className={`${s.item_property || ''} ${property.key}`}>
                <span
                  className={`return-item-${itemIndex}-property-${index}-key`}
                  dangerouslySetInnerHTML={{
                    __html: `${language[`returns.item.${property.key}`] || property.key}:`,
                  }}
                />{' '}
                {exchangeAttributes && exchangeAttributes[propertyKey] ? (
                  <ChangeIndicator
                    before={getItemPropertyDisplay({ property, item, itemQty })}
                    after={exchangeAttributes[propertyKey]}
                  />
                ) : (
                  <span
                    className={`return-item-${itemIndex}-property-${index}-value`}
                    dangerouslySetInnerHTML={{
                      __html: getItemPropertyDisplay({ property, item, itemQty }),
                    }}
                  />
                )}
              </li>
            );
          })}
        {item.item_price !== undefined && !item.display_default_properties && (
          <li className={`${s.item_property || ''} item-price-display`}>
            <span
              className={`return-item-${itemIndex}-price-key`}
              dangerouslySetInnerHTML={{ __html: language['returns.item.price_label'] }}
            />{' '}
            {exchangeAttributes && exchangeAttributes.price ? (
              <ChangeIndicator
                before={currencyService.formatPrice(item.item_price)}
                after={exchangeAttributes.price}
              />
            ) : (
              <span
                className={`return-item-${itemIndex}-price-value`}
                dangerouslySetInnerHTML={{ __html: currencyService.formatPrice(item.item_price) }}
              />
            )}
          </li>
        )}
        {item.item_qty !== undefined && !item.display_default_properties && (
          <li className={`${s.item_property || ''} return-item-qty`}>
            <span
              className={`return-item-${itemIndex}-qty-key`}
              dangerouslySetInnerHTML={{ __html: language['returns.item.qty_label'] }}
            />{' '}
            {exchangeAttributes && exchangeAttributes.quantity ? (
              <ChangeIndicator
                before={getQuantity({ item, itemQty })}
                after={exchangeAttributes.quantity}
              />
            ) : (
              <span
                className={`return-item-${itemIndex}-qty-value`}
                dangerouslySetInnerHTML={{
                  __html: getQuantity({ item, itemQty }),
                }}
              />
            )}
          </li>
        )}
        {item.item_category && !item.display_default_properties && (
          <li className={`${s.item_property || ''} return-item-category`}>
            <span
              className={`return-item-${itemIndex}-category-key`}
              dangerouslySetInnerHTML={{ __html: language['returns.item.category_label'] }}
            />{' '}
            <span
              className={`return-item-${itemIndex}-category-value`}
              dangerouslySetInnerHTML={{ __html: item.item_category }}
            />
          </li>
        )}
        {showReturnDate && (
          <li className={`${s.item_property || ''} return-item-return-date`}>
            <Language
              langKey="returns.item.return_date_label"
              className={`return-item-${itemIndex}-return-date-key`}
            />
            <span className={`return-item-${itemIndex}-return-date-value`}>
              {getDateTime({
                locale,
                date: item.max_return_date,
                options: {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                },
              })}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};

ItemProperties.defaultProps = {
  itemIndex: undefined,
  itemQty: undefined,
  exchangeAttributes: undefined,
};

ItemProperties.propTypes = {
  item: PropTypes.object.isRequired,
  itemIndex: PropTypes.number,
  language: PropTypes.object.isRequired,
  itemQty: PropTypes.number,
  exchangeAttributes: PropTypes.object,
  locale: PropTypes.string.isRequired,
};
